import { NotAvailableDialogComponent } from 'src/app/shared/components/not-available-dialog/not-available-dialog.component';
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-property-valuations',
  templateUrl: './property-valuations.component.html',
  styleUrls: ['./property-valuations.component.scss']
})
export class PropertyValuationsComponent implements AfterViewInit {

  @ViewChild('sidenav') sidenav: MatSidenav;

  tabIndex = -1;

  open = false;
  isShow = true;
  isMenuOpen = false;
  showLevelOne = false;
  showLevelTwo = false;
  addOverflow = false;

  constructor(public dialog: MatDialog) { }

  ngAfterViewInit(): void { }

  ngOnInit(): void {
    this.openDialog();
  }

  openDialog(): void {
    this.dialog.open(NotAvailableDialogComponent);
  }

  onToolbarMenuToggle() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  close() {
    this.open = false;
    this.isShow = true;
    this.sidenav.close();
  }

  openLearnMoreOne(index: number) {
    this.open = true;
    this.isShow = false;
    this.showLevelOne = true;
    this.showLevelTwo = false;
    this.sidenav.open();
    this.tabIndex = index;
  }

  openLearnMoreTwo(index: number) {
    this.open = true;
    this.isShow = false;
    this.showLevelTwo = true;
    this.showLevelOne = false;
    this.sidenav.open();
    this.tabIndex = index;
  }
}
